import React from "react";
import { Alert, Button } from "antd";
import {
  PAYMENT_EMAIL_RESEND_BUTTON_LABEL,
  PAYMENT_EMAIL_SMTP_FLAG_MESSAGE,
} from "./paymentRequestEmail";

/**
 * Flag de falha de envio do e-mail de solicitação de pagamento.
 * O botão Reenviar não esconde a flag; só o sucesso do envio a remove.
 */
const PaymentEmailFailureAlert = ({
  visible,
  loading = false,
  onResend,
  style,
}) => {
  if (!visible) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 12, ...style }}
      message={PAYMENT_EMAIL_SMTP_FLAG_MESSAGE}
      action={
        <Button size="small" loading={loading} onClick={onResend}>
          {PAYMENT_EMAIL_RESEND_BUTTON_LABEL}
        </Button>
      }
    />
  );
};

export default PaymentEmailFailureAlert;
